export enum CustomsChannel {
  RED = 'RED',
  GREEN = 'GREEN',
  AMBER = 'AMBER',
  DETAIL = 'DETAIL',
  HRC = 'HRC'
}
